import { Helmet } from 'react-helmet-async';

import { Card, CardBody, CardHeader } from '@heroui/react';

import { MagicWandIcon } from '@radix-ui/react-icons';

import { useAuthFlow } from '@/features/auth/hooks/use-auth-flow';
import { CodeStep } from '@/features/auth/ui/code-step';
import { EmailStep } from '@/features/auth/ui/email-step';

export const RegisterPage = () => {
  const {
    step,
    userEmail,
    isCodeError,
    isVerifying,
    isResending,
    isSubmitting,
    timeLeft,
    canResend,
    submitEmail,
    submitCode,
    resendCode,
    goBackToEmail,
  } = useAuthFlow();

  return (
    <>
      <Helmet>
        <title>Sign In - FameCreator</title>
        <meta
          name="description"
          content="Join FameCreator to start creating amazing AI-powered content. Sign up with just your email address."
        />
      </Helmet>
      <Card className="w-full max-w-md bg-white/90 backdrop-blur-xl border-gray-100 shadow-2xl rounded-2xl">
        <CardHeader className="flex flex-col items-center pb-6 pt-8 px-8">
          <div className="w-12 h-12 bg-gradient-to-r from-violet-500 to-purple-400 rounded-xl flex items-center justify-center mb-4 shadow-lg shadow-purple-500/25">
            <MagicWandIcon className="w-6 h-6 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 text-center">
            {step === 'email' ? 'Sign In' : 'Enter Verification Code'}
          </h1>
          <p className="text-small text-gray-600 text-center">
            {step === 'email'
              ? 'Enter your email to get started'
              : `We sent a 6-digit code to ${userEmail}`}
          </p>
        </CardHeader>

        <CardBody className="px-8 pb-8">
          {step === 'email' ? (
            <EmailStep onSubmit={submitEmail} isSubmitting={isSubmitting} />
          ) : (
            <CodeStep
              email={userEmail}
              onSubmit={submitCode}
              onBack={goBackToEmail}
              onResend={resendCode}
              isVerifying={isVerifying}
              isCodeError={isCodeError}
              isResending={isResending}
              timeLeft={timeLeft}
              canResend={canResend}
            />
          )}
        </CardBody>
      </Card>
    </>
  );
};
